var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        "return-value": _vm.selectedDates,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "auto",
      },
      on: {
        "update:returnValue": function ($event) {
          _vm.selectedDates = $event
        },
        "update:return-value": function ($event) {
          _vm.selectedDates = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        label: _vm.cf.label,
                        "prepend-icon": "mdi-calendar",
                        readonly: "",
                      },
                      model: {
                        value: _vm.selectedDates,
                        callback: function ($$v) {
                          _vm.selectedDates = $$v
                        },
                        expression: "selectedDates",
                      },
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("v-date-picker", {
        attrs: {
          "active-picker": _vm.activePicker,
          "no-title": "",
          scrollable: "",
          min: _vm.cf.min,
          max: _vm.cf.max,
          "first-day-of-week": _vm.firstDayOfWeek,
        },
        on: {
          "update:activePicker": function ($event) {
            _vm.activePicker = $event
          },
          "update:active-picker": function ($event) {
            _vm.activePicker = $event
          },
          change: _vm.submit,
        },
        model: {
          value: _vm.selectedDates,
          callback: function ($$v) {
            _vm.selectedDates = $$v
          },
          expression: "selectedDates",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/bot/datePicker/bot.date.picker.vue